const REDIRECT_TIMEOUT = 5000;

export default REDIRECT_TIMEOUT;
